<template>
  <!-- eslint-disable vue/no-v-html -- APP_ICON holds static path markup, never user input -->
  <svg
    :class="APP_ICON_SIZE[size]"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    v-html="APP_ICON[name]"
  ></svg>
</template>
<script setup>
// 1. Import necessary components
import { APP_ICON, APP_ICON_SIZE } from '@/shared/constants/icons';
// 2. Use
defineProps({
  name: { type: String, required: true, validator: (value) => value in APP_ICON },
  size: { type: String, default: 'control', validator: (value) => value in APP_ICON_SIZE },
});
// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>
